import { useEffect, type ReactNode } from "react";
import { X } from "lucide-react";

export function Modal({ open, onClose, children, testId }: { open: boolean; onClose: () => void; children: ReactNode; testId: string }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center bg-ink/60 p-0 backdrop-blur-sm sm:items-center sm:p-6" onClick={onClose}>
      <div role="dialog" aria-modal="true" data-testid={testId} onClick={(e) => e.stopPropagation()}
        className="rise relative max-h-[92vh] w-full max-w-md overflow-y-auto rounded-t-[28px] border-[3px] border-ink bg-cream p-5 pop-shadow-lg sm:rounded-[28px] sm:p-6">
        <button onClick={onClose} data-testid={`${testId}-close`} aria-label="Close"
          className="absolute right-3 top-3 rounded-full border-2 border-ink bg-white p-1.5 transition-transform hover:rotate-90">
          <X className="h-4 w-4" strokeWidth={3} />
        </button>
        {children}
      </div>
    </div>
  );
}
